/**
 * Spontán erjesztésű   * FARO - Faro   * GUEUZE - Gueuze
 */
export type SpontaneouslyFermented = 'FARO' | 'GUEUZE';

export const SpontaneouslyFermented = {
  Faro: 'FARO' as SpontaneouslyFermented,
  Gueuze: 'GUEUZE' as SpontaneouslyFermented,
};
